module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/plan01_stay-0d7316c684e62e652d71b698709957a0.jpg";